import { render, staticRenderFns } from "./list-argolla-carrito.vue?vue&type=template&id=2ea105d3"
import script from "./list-argolla-carrito.vue?vue&type=script&lang=js"
export * from "./list-argolla-carrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports